// import { logOut } from '../redux/features/agentSlice';
// import { useLayout } from '../../_metronic/layout/core';
// import { toAbsoluteUrl } from '../../_metronic/helpers';
// import { KTIcon } from '../../_metronic/helpers';
// import { useDispatch } from 'react-redux';

import {useLayout} from '../../core'
import {toAbsoluteUrl} from '../../../helpers'
import {KTIcon} from '../../../helpers'
import {useDispatch} from 'react-redux'

const MobileHeader = () => {
  const dispatch = useDispatch()
  const {config} = useLayout()
  if (!config.app?.header?.display) {
    return null
  }

  const handleLogout = () => {
    dispatch({type: 'USER_LOGOUT'})
  }

  //manually fix the bug of cant toggle the sidebar for mobile view during login
  const addClassName = () => {
    const remove = () => {
      var element = document.getElementById("custom-overlay");
      if(element) element.remove();
      d.classList.remove("drawer-on");
    }

    var d = document.getElementById('kt_app_sidebar')
    d.className += ' drawer-on'
    var overlayElem = document.createElement('div')
    overlayElem.style.cssText = 'z-index: 105;'
    overlayElem.className = 'drawer-overlay'
    overlayElem.id = 'custom-overlay'
    //remove the overlay element when click on the element itself
    overlayElem.addEventListener("click", remove, false);
    document.body.appendChild(overlayElem)

    //remove the overlay element when click on menu links
    const allMenuItems = document.querySelectorAll('.menu-link')
    allMenuItems.forEach(item => {item.addEventListener("click", remove, false);})
  }


  return (
    <div className='mobile-header-wrapper'>
      <div className='mobile-header'>
        <div className='mobile-btn-logo'>
          {config.app.sidebar?.display && (
            <>
              <div>
                <div
                  className='btn btn-icon w-35px h-35px beadcrum-mobile-menu'
                  // id='kt_app_sidebar_mobile_toggle'
                  onClick={addClassName}
                  // data-bs-toggle="offcanvas" data-bs-target="#kt_app_sidebar"
                >
                  <KTIcon iconName='text-align-left' className='beadcrum-mobile-menu-icon fs-1' />
                </div>
              </div>
              <div
                className='d-flex align-items-center d-lg-none ms-n2 me-2'
                title='Show sidebar menu'
              />
            </>
          )}
          <img
            alt='Next Six Emblem'
            src={toAbsoluteUrl('/media/sidebar/nextsix-emblem.svg')}
            className='mobile-header-logo'
          />
        </div>
        <div className='mobile-logout-btn' onClick={handleLogout}>
          <svg
            className='dashboard-logout-icon'
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='19'
            viewBox='0 0 22.414 20'
          >
            <path
              id='Path_9214'
              data-name='Path 9214'
              d='M626,684l4,4m0,0-4,4m4-4H617m6-7.8a8.382,8.382,0,0,0-4.333-1.2,9.006,9.006,0,0,0,0,18A8.382,8.382,0,0,0,623,695.8'
              transform='translate(-609 -678)'
              fill='none'
              stroke='#a7a9ac'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='1.5'
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default MobileHeader
